import { render, staticRenderFns } from "./EntradaBalaDetail.vue?vue&type=template&id=37a27fd2&scoped=true"
import script from "./EntradaBalaDetail.vue?vue&type=script&lang=js"
export * from "./EntradaBalaDetail.vue?vue&type=script&lang=js"
import style0 from "./EntradaBalaDetail.vue?vue&type=style&index=0&id=37a27fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a27fd2",
  null
  
)

export default component.exports